export const checkIsValueExistingInEnum = (enumObject, value) => {
    return Object.values(enumObject).includes(value);
};
